module.exports = __webpack_public_path__ + "img/close.43db593b.svg";